import React from 'react';
import { motion } from 'framer-motion';
import { MaintenanceRequest } from '../../types';
import { Clock, Wrench, AlertCircle, CheckCircle, ChevronRight } from 'lucide-react';
interface RequestCardProps {
  request: MaintenanceRequest;
  onClick: () => void;
}
export function RequestCard({
  request,
  onClick
}: RequestCardProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'submitted':
        return 'bg-blue-100 text-blue-800';
      case 'assigned':
        return 'bg-purple-100 text-purple-800';
      case 'in_progress':
        return 'bg-yellow-100 text-yellow-800';
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'cancelled':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getUrgencyIcon = (urgency: string) => {
    if (urgency === 'emergency' || urgency === 'high') {
      return <AlertCircle className="h-4 w-4 text-red-500" data-id="element-1360" />;
    }
    return <Clock className="h-4 w-4 text-gray-400" data-id="element-1361" />;
  };
  return <motion.div onClick={onClick} whileHover={{
    y: -2
  }} className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm cursor-pointer hover:shadow-md transition-all" data-id="element-1362">
      <div className="flex justify-between items-start mb-3" data-id="element-1363">
        <div className="flex items-center space-x-2" data-id="element-1364">
          <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${getStatusColor(request.status)}`} data-id="element-1365">
            {request.status.replace('_', ' ')}
          </span>
          {request.urgency === 'emergency' && <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 animate-pulse" data-id="element-1366">
              Emergency
            </span>}
        </div>
        <span className="text-xs text-gray-500" data-id="element-1367">
          {new Date(request.submittedAt).toLocaleDateString()}
        </span>
      </div>

      <div className="flex items-start space-x-3 mb-4" data-id="element-1368">
        <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-1369">
          <Wrench className="h-5 w-5 text-gray-500" data-id="element-1370" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-1371">
          <h4 className="text-sm font-medium text-gray-900 capitalize mb-1" data-id="element-1372">
            {request.category} Issue
          </h4>
          <p className="text-sm text-gray-500 line-clamp-2" data-id="element-1373">
            {request.description}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-gray-100" data-id="element-1374">
        <div className="flex items-center text-xs text-gray-500" data-id="element-1375">
          {getUrgencyIcon(request.urgency)}
          <span className="ml-1 capitalize" data-id="element-1376">{request.urgency} Priority</span>
        </div>
        <ChevronRight className="h-4 w-4 text-gray-400" data-id="element-1377" />
      </div>
    </motion.div>;
}